import { types } from '../reducers/formReducer';

// eslint-disable-next-line import/prefer-default-export
export const createForm = (values) => ({
  type: types.POST,
  payload: values,
});

export const updateForm = (values) => ({
  type: types.PUT,
  payload: values,
});

export const removeForm = (item) => ({
  type: types.DELETE,
  item,
});

export const reloadForm = (items) => ({
  type: types.RELOAD,
  payload: items,
});

export const resetForm = () => ({
  type: types.RESET,
});

export const updateLocalForm = (item, attribute) => ({
  type: types.UPDATE_ITEM,
  payload: { item, attribute },
});

export { getDraftId } from '../reducers/formReducer';
